require("!!/home/builder/jenkins/workspace/2.10.1_composer-web/c4-composer-web/node_modules/script-loader/addScript.js")(require("!!/home/builder/jenkins/workspace/2.10.1_composer-web/c4-composer-web/node_modules/raw-loader/index.js!/home/builder/jenkins/workspace/2.10.1_composer-web/c4-composer-web/node_modules/web-animations-js/web-animations.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/web-animations-js/web-animations.min.js
// module id = 825
// module chunks = 1